import React, {useState} from 'react'
import Image from '@components/Image'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './styles.module.css'

export default function SectionAccordion({
  initiallyOpen = true,
  headerTitle,
  headerLegend,
  children,
  containerClassName = '',
  titleClassName = '',
  marginClassName = '',
  arrowClassName = ''
}) {
  const [open, setOpen] = useState(initiallyOpen)

  return (
    <div className={classnames(styles.container, open ? '' : styles.close, containerClassName)}>
      <div className={classnames(styles.header, open ? styles.headerMargin : '', marginClassName)}>
        <div
          className={classnames(styles.headerTitle, titleClassName)}
          onClick={() => setOpen(!open)}>
          {headerTitle} <span>{headerLegend}</span>
        </div>
        <div
          className={classnames(styles.arrow, open ? '' : styles.invert, arrowClassName)}
          onClick={() => setOpen(!open)}>
          <Image src="/images/icons/open_arrow.svg" alt="ocultar" height={15} width={15} />
        </div>
      </div>
      <div className={open ? styles.body : styles.hide}>{children}</div>
    </div>
  )
}

SectionAccordion.propTypes = {
  initiallyOpen: PropTypes.bool,
  headerTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headerLegend: PropTypes.string,
  children: PropTypes.node,
  containerClassName: PropTypes.string,
  titleClassName: PropTypes.string,
  marginClassName: PropTypes.string,
  arrowClassName: PropTypes.string
}
